// extracted by mini-css-extract-plugin
export default {"SideMenuHeader":"SideMenuHeader_SideMenuHeader__yieDU","SideMenuLogo":"SideMenuHeader_SideMenuLogo__W5i8k"};